import template from "./metadata-modal.html";
import "./metadata-modal.less";
import { EVENT_LOGOUT } from "../../../../../../constants";

export class Controller {
	constructor(appState, eventBus, $scope, toastr) {
		this.appState = appState;
		this.eventBus = eventBus;
		this.$scope = $scope;
		this.$toastr = toastr;

		this.export = { 
			Metadata: [],
			...this.resolve.reportExport
		};
	}

	$onInit() {
		this.eventBus.register(EVENT_LOGOUT, () => { this.handleClose(); }, this.$scope);
	}

	handleClose() {
		this.modalInstance.dismiss();
	}
}

export default angular
	.module("vesl.components.metadata-modal", [])
	.component("metadataModal", {
		controller: Controller,
		template,
		bindings: {
			close: "&",
			dismiss: "&",
			modalInstance: "<",
			resolve: "<"
		}
	}).name;
